import React from 'react';
import Translator from '../../../core/i18n';
import { Log } from 'ng2-logger';
import { IAppState, IAction } from '../../../models/action/core';
import { connect } from 'react-redux';
import { ISelectedAnnouncementPageProps } from '../../../models/pages/selectedAnnouncementPage';
import * as Actions from '../../../store/actions/announcementPage';
import { Dispatch } from 'redux';
import { Common } from '../../../core/common';
import Moment from 'moment';
import { SecureImage } from '../../core/secureImage';
import Processing from '../processing/main';
import { SecurityContextType, SecurityPermissionType } from '../../../core/SecurityContext';
import { UserType } from '../../../models/enums/userType';
import Loading from '../../../components/loading/loading';
import ImageAnnouncementsNotFound from '../../../static/images/announcement.svg';
import { IPreference } from '../../../models/action/profile';
import { any } from 'prop-types';
import ContentLoader from 'react-content-loader';
import ProgressCircle from '../../progress-circle/progress-circle';
import Tooltip from '../../tooltip/main';
import { Modal, Table } from 'reactstrap';
import Paginate from '../../table/paginate';

const T = Translator.create();
const _logger = Log.create('mainManu.tsx');
let _common: Common;
const receiverNumber = 7;

const SENT_TAB = '1';

export class SelectedAnnouncement extends React.Component<any> {
    public state = {
        open: false,
        openChild: false,
        openChildren: false,
        isReportModalShow:false,
        isSearchBoxOpen: false,
        query: '',
        isShow: false,
    };

    constructor(props: any) {
            super(props);
            _common = new Common();
            this.openReportModal = this.openReportModal.bind(this);
            this.setCloseReportModal = this.setCloseReportModal.bind(this);
        }

    public onClick = () => {
        this.props.modalTrigger();
    };
    public openReportModal() {
        this.setState({ isReportModalShow: true });
    }
    public setCloseReportModal() {
        this.setState({ isReportModalShow: false });
    }

    public getUserType = (userTypeId: UserType) => {
        if (userTypeId === UserType.Student) {
            return T.t('r_gen_student');
        }
        if (userTypeId === UserType.User) {
            return T.t('r_gen_user');
        }
        if (userTypeId === UserType.Teacher) {
            return T.t('r_gen_teacher');
        }
        if (userTypeId === UserType.Parent) {
            return T.t('r_gen_parent');
        }
        if (userTypeId === UserType.Guest) {
            return T.t('r_gen_guest');
        }
    };

    public onClickItems(val: string) {
        switch (val) {
            case 'Edit': {
                if (this.props.selectedAnnouncement.announcementId) {
                    this.props.dispatch(
                        Actions.getAnnouncementData(this.props.selectedAnnouncement.announcementId, 'getSelectedAnnouncement', 'get', this.callback)
                    );
                }
                break;
            }
            default:
                break;
        }
    }
    onClickSearchBox = () => {

        let searchBoxValue = true;

        if (this.state.isSearchBoxOpen === true) {
            searchBoxValue = false;
        }

        this.setState({ isSearchBoxOpen: searchBoxValue });
    }
    callback = (val: string) => {
        switch (val) {
            case 'Edit': {
                if (this.props.modalTrigger && this.props.selectedAnnouncement.announcementId) {
                    this.props.modalTrigger();
                }
                break;
            }
            case 'Delete': {
                this.props.dispatch(Actions.getAnnouncementsAction(SENT_TAB, 'announcementList', 'get', 20, 0));
                break;
            }
            default:
                break;
        }
    };

    public clickToDownload = (e: any) => {
        const filepath = e.currentTarget!.getAttribute('data-filepath').toString();
        const fileName = e.currentTarget!.getAttribute('data-filename').toString();
        if (filepath && fileName) {
            _common.DownloadLink(filepath + '/download', fileName);
        }
    };
    showMoreAnnouncementReceiver = () => {
        if(!this.state.isShow){
            this.setState({ isShow:true});
        }
        else
        {
            this.setState({isShow: false});
        }
    }

     returnAnnouncementReceiver = () => {

        let returnArr:any = [];

        {this.props.selectedAnnouncement.contextHeaders &&
            this.props.selectedAnnouncement.contextHeaders.length > 0
            && this.props.selectedAnnouncement.contextHeaders.slice(0, this.state.isShow ? this.props.selectedAnnouncement.contextHeaders.length: receiverNumber).map((context: any, headerIndex: any) => {
                returnArr.push (
                    <button style={{ cursor: 'default' }} key={headerIndex} className="category-tag-circle tag-gray">
                        {context.header + ' '}({this.getUserType(context.userType)})
                    </button>
                );
            })
            }

            if(this.props.selectedAnnouncement.contextHeaders.length> receiverNumber){

                returnArr.push(
                    <button
                    onClick={this.showMoreAnnouncementReceiver}
                    className={this.state.isShow ? 'float-right ml-3' : 'float-right show_more_text'}
                    style={{
                        fontSize: '12px',
                        margin: '0px 0px 0px 10px',
                        color: this.state.isShow ? '#ff0000' : '#39B27B',
                        border: 'none',
                        background: 'none'
                    }}
                >
                    {T.t(this.state.isShow ? 'r_gen_show_less' : 'r_gen_show_more')}
                </button>
                )
            }

            return returnArr;

     }
    public render() {
        return (
            <>
                {!this.props.selectedAnnouncement ? (
                    <div className="announcement-tabs-section p-0" style={{ backgroundColor: 'white' }}>
                        {
                            <div className="create-announcement text-center">{/*
                                <div className="d-inline-block" id="getSelectedAnnouncement_Content">
                                    {Common.HasPermission(SecurityContextType.Organization, SecurityPermissionType.Announcement_Add, '') &&
                                        this.props.currentTab === SENT_TAB &&
                                        !this.props.classId && (
                                            <button className="btn btn-outline mr-2" type="button" onClick={this.onClick}>
                                                {T.t('r_announcement_create')}
                                            </button>
                                        )}
                                </div>*/}
                            </div>
                        }
                    </div>

                ) : (
                    <div id="announcement-selected" className="announcement-tabs-section p-0 mobile_chat_panel display_sm_none">
                        {
                            <div className="announcement-detail-content">
                                <div style={{ padding: '20px' }} className="conversation-header d-flex align-items-center justify-content-between">
                                    <a
                                        type="button"
                                        onClick={() => {
                                            const getAllActiveClass = document.getElementsByClassName('mobile_chat_panel');
                                            for (let index = 0; index < getAllActiveClass.length; index++) {
                                                getAllActiveClass[index].classList.remove('mobile_chat_panel');
                                            }
                                        }}
                                        id="backToAnnouncementList"
                                        className="display_sm_flex"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <i className="material-icons">chevron_left</i>
                                    </a>
                                    <h6 className='mb-0' style={{wordBreak:'break-word'}}>{this.props.selectedAnnouncement.subject}</h6>
                                    <div style={{ color: 'white' }}>
                                    </div>
                                    {this.props.currentTab === SENT_TAB ? (
                                        <Processing
                                            modalTrigger={this.props.modalTrigger}
                                            updateAnnouncementId={this.props.selectedAnnouncement.announcementId}
                                        />
                                    ) : (
                                        ''
                                    )}
                                </div>
                                <Loading spinnerId={'getSelectedAnnouncement'} class="container">
                                    <div style={{}}>
                                        <ContentLoader
                                            speed={2}
                                            backgroundColor="#f3f3f3"
                                            foregroundColor="#ecebeb"
                                            viewBox="0 0 200 150"
                                            style={{ width: '100%' }}
                                        >
                                            <circle cx="25" cy="15" r="15" />
                                            <rect x="16" y="36" rx="0" ry="0" width="27" height="0" />
                                            <rect x="19" y="36" rx="0" ry="0" width="15" height="4" />
                                            <rect x="47" y="13" rx="0" ry="0" width="83" height="5" />
                                            <rect x="5" y="56" rx="0" ry="0" width="132" height="6" />
                                            <rect x="5" y="71" rx="0" ry="0" width="131" height="16" />
                                            <rect x="5" y="95" rx="0" ry="0" width="131" height="6" />
                                        </ContentLoader>
                                    </div>
                                </Loading>
                                <div id="getSelectedAnnouncement_Content">
                                    <div id="announcement-content" className=" container" style={{ paddingLeft: '44px !important' }}>
                                        <div className="user-info d-flex flex-wrap">
                                            {this.props.selectedAnnouncement.fromAvatarPath ? (
                                                <SecureImage
                                                    style={{ borderRadius: 100 }}
                                                    class={'userProfile'}
                                                    imageUrl={this.props.selectedAnnouncement.fromAvatarPath}
                                                />
                                            ) : (
                                                ''
                                            )}
                                            <span style={document.body.getAttribute('dir') == 'ltr' ? {marginLeft: "0.5rem", marginRight: "1rem"} : {marginRight: "0.5rem", marginLeft: "1rem"} }>{this.props.selectedAnnouncement.fromDisplayName}</span>
                                            <i className="material-icons" style={document.body.getAttribute('dir') == 'ltr' ? {marginInlineEnd: "1.5rem"} : {marginInlineStart: "1.5rem"} }>arrow_forward</i>
                                          {this.returnAnnouncementReceiver()}
                                        </div>
                                        <div className="announcement-stats border-bottom pb-3 mb-4">
                                            <div>
                                                <button className="small-tag tag-web">web</button>
                                            </div>
                                            {/* <div>
                                                    {this.props.userType === UserType.Student ? '':
                                                        <div className='d-flex align-items-center'>
                                                                <ProgressCircle percent={50} />

                                                            <button onClick={this.openReportModal} className="category-tag-square tag-gray mr-2">
                                                                <i className="material-icons">bar_chart</i>
                                                                {T.t('r_gen_report')}
                                                            </button>
                                                        </div>
                                                    }
                                            </div> */}
                                        </div>
                                        <div className="date d-inline-block">
                                            <span>
                                                {T.t('r_announcement_date').replace('{0}', Moment(this.props.selectedAnnouncement.createdDate.toString()).format(this.props.findDateFormat(false) + ' HH:mm'))}
                                            </span>
                                        </div>
                                        <div className="announcement-content">
                                            <p className={ (!_common.isArabic(this.props.selectedAnnouncement.content,  document.body.getAttribute('dir')) ? 'arabic-text-direction' : '')} dangerouslySetInnerHTML={{ __html: this.props.selectedAnnouncement.content }} />
                                        </div>
                                        <div className="mt-4 mb-4 border-bottom" />
                                        <div className="upload-files-name">
                                            {this.props.selectedAnnouncement.files.map((file: any, fileIndex: any) => (
                                                <button
                                                    key={fileIndex}
                                                    className="file-name"
                                                    onClick={this.clickToDownload}
                                                    data-filepath={file && file.path}
                                                    data-filename={file && file.fileName}
                                                >
                                                    <i className="mr-1 material-icons" style={{ verticalAlign: 'middle' }}>
                                                        attach_file
                                                    </i>
                                                    {file.fileName}
                                                    <span style={{ verticalAlign: 'inherit' }}>
                                                        {_common.BytesToSize(file ? parseInt(file.size, 10) : 0)}
                                                    </span>
                                                </button>
                                            ))}
                                        </div>
                                        {this.props.selectedAnnouncement.files.length > 0 ? (
                                            <>
                                                <div className="upload-file-display">
                                                    <div className="row">
                                                        {this.props.selectedAnnouncement.files.map((file: any, fileIndex: any) =>
                                                            /\.((jpe?g)|(png)|(gif))(\?|$)/gi.test(file.fileName) ? (
                                                                <div key={fileIndex} className="col-md-3">
                                                                    <SecureImage imageUrl={file.path} preventCaching={true} />
                                                                </div>
                                                            ) : (
                                                                ''
                                                            )
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="mt-4 mb-4 border-bottom" />
                                            </>
                                        ) : (
                                            ''
                                        )}
                                        {Common.HasPermission(SecurityContextType.Organization, SecurityPermissionType.Announcement_Add, '') &&
                                            this.props.currentTab === SENT_TAB &&
                                            !this.props.classId && (
                                                <div className="button-options pb-4">
                                                    <div className="row align-items-center">{/*
                                                    <div className="col-lg-6">
                                                        <button
                                                            // tslint:disable-next-line
                                                            onClick={() => this.onClickItems('Edit')}
                                                            className="mr-2 category-tag-square tag-gray"
                                                        >
                                                            <i className="material-icons mr-2">bar_chart</i>{T.t('r_gen_edit')}
                                                        </button>
                                                    </div>
                                                    <div className="col-lg-6 text-lg-right">
                                                        <button onClick={this.props.modalTrigger} className="btn btn-green" type="button">
                                                            {T.t('r_announcement_create')}
                                                        </button>
                                                    </div>
                                                    */}
                                                    </div>
                                                </div>
                                            )}
                                    </div>
                                </div>

                            </div>
                        }
                    </div>
                )}
                    <Modal
                    isOpen={this.state.isReportModalShow}
                    toggle={this.setCloseReportModal}
                    fade={true}
                    modalClassName='reportModal'
                    size="xl"
                    style={{ display: 'block', animationDuration: '0.5s' }}
                    backdrop={'static'}>
                            <div className="modal-header">
                                <h5 className="modal-title d-flex align-items-center">{T.t('r_report_annoucement')}</h5>
                                <div className="d-flex">
                                <button className="category-tag-square tag-gray mr-2">
                                    <i className="material-icons">get_app</i>
                                    {T.t("r_save_report")}
                                </button>
                                <button
                                    onClick={this.setCloseReportModal}
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <i style={{ color: '#000' }} className="material-icons">
                                        close
                                    </i>
                                </button>
                                </div>
                            </div>
                            <div className="modal-body px-4">
                                <div className="stats-cards grid-3 gap-4">
                                    <div className="card web">
                                        <div className="title">{T.t("r_report_web")}</div>
                                        <div className="content">
                                            <div className="stat">{T.t("r_report_total_participant")} <span>680</span></div>
                                            <div className="stat">{T.t("r_report_transmitted")} <span>640</span></div>
                                            <div className="stat">{T.t("r_report_readed")}<span>71</span></div>
                                        </div>
                                        <div className="border-bottom "></div>
                                        <div className="footer">
                                            <div className='d-flex flex-column'>
                                                <span>{T.t("r_report_sended_btn")}</span>
                                                <ProgressCircle percent={90}></ProgressCircle>
                                            </div>

                                            <div className='d-flex flex-column'>
                                                <span>{T.t("r_report_readed_btn")}</span>
                                                <ProgressCircle percent={60}></ProgressCircle>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card email">
                                        <div className="title">{T.t("r_report_email")}</div>
                                        <div className="content">
                                            <div className="stat">{T.t("r_report_total_participant")} <span>680</span></div>
                                            <div className="stat">{T.t("r_report_transmitted")} <span>640</span></div>
                                            <div className="stat">{T.t("r_report_readed")}<span>71</span></div>
                                        </div>
                                        <div className="border-bottom "></div>
                                        <div className="footer">
                                            <div className='d-flex flex-column align-items-center'>
                                                <span>{T.t("r_report_sended_btn")}</span>
                                                <ProgressCircle percent={90}></ProgressCircle>
                                            </div>

                                            <div className='d-flex flex-column align-items-center'>
                                                <span>{T.t("r_report_readed_btn")}</span>
                                                <ProgressCircle percent={60}></ProgressCircle>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card sms">
                                        <div className="title">{T.t("r_report_sms")}</div>
                                        <div className="content">
                                            <div className="stat">{T.t("r_report_total_participant")} <span>-</span></div>
                                            <div className="stat">{T.t("r_report_transmitted")} <span>-</span></div>
                                            <div className="stat">{T.t("r_report_readed")}<span>-</span></div>
                                        </div>
                                        <div className="border-bottom "></div>
                                        <div className="footer">
                                            <div className='d-flex flex-column'>
                                                <span>{T.t("r_report_sended_btn")}</span>
                                                <ProgressCircle percent={0}></ProgressCircle>
                                            </div>

                                            <div className='d-flex flex-column'>
                                                <span>{T.t("r_report_readed_btn")}</span>
                                                <ProgressCircle percent={0}></ProgressCircle>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                        <div className='d-flex justify-content-between w-100 mt-5'>
                            <span style={{fontWeight:'500'}}>{T.t("r_report_stats_by_participant")}</span>

                            <div className="lead-search-bar">
                                <div className="question-filter p-0">
                                    <div className="options">
                                        <button
                                            className="ml-3 mr-3"
                                            onClick={() => this.onClickSearchBox()}

                                            style={{ display: this.state.isSearchBoxOpen ? 'none' : 'block', border: 'none', background: 'none' }}
                                        >
                                            <i className="material-icons mr-2 align-middle">search</i>
                                            {T.t('r_gen_search')}
                                        </button>
                                    </div>
                                    <div
                                        id="assignment-search"
                                        className={this.state.isSearchBoxOpen ? 'search collapse show' : 'search collapse'}
                                        style={{ position: 'inherit' }}
                                    >
                                        <div className="input-group">
                                            <div
                                                data-toggle="collapse"
                                                className="input-group-prepend collapsed"
                                                aria-expanded="false"
                                            >
                                                <div
                                                    className="input-group-text"
                                                    onClick={() => {
                                                        this.setState({
                                                            ...this.state,
                                                            query: '',
                                                            isSearchBoxOpen: !this.state.isSearchBoxOpen
                                                        });
                                                    }}
                                                >
                                                    <i className="material-icons">close</i>
                                                </div>
                                            </div>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="inlineFormInputGroup"
                                                placeholder={T.t('r_gen_search')}
                                                value={this.state.query}
                                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                    const regExp = new RegExp(event.target.value, 'i');

                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                                <Table
                                        className="table-user-list table-striped table-ellipsis table-mobile mt-4 annoucement_report_table"
                                        striped={true}
                                        hover={true}
                                        borderless={true}
                                    >
                                    <thead>
                                        <tr>
                                            <th className="border-bottom">{T.t("r_profile_photo")}</th>
                                            <th className="border-bottom">{T.t("r_name_surname")}</th>
                                            <th className="border-bottom">{T.t("r_gen_program")}</th>
                                            <th className="border-bottom">{T.t("r_see_annoucement_date")}</th>
                                            <th className="border-bottom">{T.t("r_report_web")}</th>
                                            <th className="border-bottom">{T.t("r_report_email")}</th>
                                            <th className="border-bottom">{T.t("r_report_sms")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><img src="https://picsum.photos/32" alt="Pro"/></td>
                                            <td>Ali Can</td>
                                            <td>Program 1</td>
                                            <td>2022-01-01</td>
                                            <td><span className="material-icons-outlined readed">done_all</span></td>
                                            <td><span className="material-icons-outlined readed">done_all</span></td>
                                            <td><span className="material-icons-outlined">done</span></td>

                                        </tr>

                                        <tr>
                                            <td><img src="https://picsum.photos/32" alt="Pro"/></td>
                                            <td>Ali Can</td>
                                            <td>Program 1</td>
                                            <td>2022-01-01</td>
                                            <td><span className="material-icons-outlined readed">done_all</span></td>
                                            <td><span className="material-icons-outlined readed">done_all</span></td>
                                            <td><span className="material-icons-outlined">done</span></td>

                                        </tr>
                                    </tbody>
                                </Table>
                                <Paginate
                                    class={'custom-paginate'} onPageChange={function (page: number): void {
                                        throw new Error('Function not implemented.');
                                    }} />
                            </div>
                </Modal>
            </>

        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ISelectedAnnouncementPageProps): ISelectedAnnouncementPageProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: ISelectedAnnouncementPageProps = Object.assign({}, ownProps, {
        selectedAnnouncement: state.announcement.selectedAnnouncement,
        selectedAnnouncementIsLoaded: state.announcement.selectedAnnouncementIsLoaded,
        userPreferences: state.profile.userPreferences
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return false;
};

const CSelectedAnnouncement = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(SelectedAnnouncement);

export default CSelectedAnnouncement;
